<div class="w-full h-full flex justify-center items-center" [ngClass]="classList">
  <nrc-icon class="w-1/2 h-1/2 opacity-50" [name]="iconName()" [fillColor]="iconColor" />
</div>
